import React from 'react';
import _get from 'lodash/get';
import useAnalytics from 'helpers/useAnalytics';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import useAttributesEditDialog from 'pages/AttributesEdit/helpers/useAttributesEditDialog';

import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import SearchIcon from '@material-ui/icons/Search';
import ExportButton from 'components/buttons/ExportButton';
import { GridToolbarContainer } from '@material-ui/data-grid';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';
import { PERSON_PROFILE_URL } from 'components/Router/consts';

const CustomToolbar = (props: any) => {
  const classes = useStyles();
  const analytics = useAnalytics();
  const location = useLocation();
  const path = location.pathname;
  const { entityTypeKey } = useParams<{ entityTypeKey?: string }>();
  const filterModel = _get(props, 'state.filter.items', []);
  const activeFilters =
    filterModel.length > 0
      ? filterModel.filter(
          (item: { value?: any }) =>
            item.value !== null && _get(item, 'value', '').toString() !== '',
        )
      : [];
  const counter = activeFilters.length;
  const { open } = props.state.preferencePanel;
  const { hideFilterPanel, showFilterPanel } = props.api.current;
  const { open: attributesEditDialogOpen } = useAttributesEditDialog(
    entityTypeKey || PERSON_ENTITY_TYPE_KEY,
  );

  const toggleFilterPanel = () => {
    if (open) {
      hideFilterPanel();
    } else {
      showFilterPanel();
    }
  };

  const handleClick = () => {
    attributesEditDialogOpen();
    if (path.includes(PERSON_PROFILE_URL)) {
      analytics.track('New Attribute Button clicked', {
        category: 'AD - Person Profiles',
      });
    } else {
      analytics.track('New Attribute Button clicked', {
        category: 'AD - Pages',
      });
    }
  };

  return (
    <GridToolbarContainer className={classes.actionBar}>
      <Button
        aria-label="toolbar filter"
        color="secondary"
        onClick={toggleFilterPanel}
        startIcon={
          <Badge badgeContent={counter} color="secondary">
            <SearchIcon color="secondary" />
          </Badge>
        }
      >
        Search
      </Button>
      <div style={{ display: 'flex' }}>
        <ExportButton classes={{ root: classes.exportButton }} formats={props.formats} />
        <Button variant="contained" color="secondary" disableElevation={true} onClick={handleClick}>
          {props.buttonText}
        </Button>
      </div>
    </GridToolbarContainer>
  );
};

const useStyles = makeStyles(theme => ({
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 2, 1, 1),
  },
  exportButton: {
    marginRight: theme.spacing(3),
  },
}));

export default CustomToolbar;
